import { render, staticRenderFns } from "./ReferPatientForm.vue?vue&type=template&id=43542e05&scoped=true"
import script from "./ReferPatientForm.vue?vue&type=script&lang=js"
export * from "./ReferPatientForm.vue?vue&type=script&lang=js"
import style0 from "./ReferPatientForm.vue?vue&type=style&index=0&id=43542e05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43542e05",
  null
  
)

export default component.exports